import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  root: {
    margin: '0 auto',
    minWidth: 500,
    width: '100%',
    maxWidth: 800,
    padding: 10,
  },
});

export default useStyles;